

import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../../hooks/useAuth';
import { Button, Fab, Typography } from '@mui/material';
import moment from "moment-jalaali";
import PropTypes from 'prop-types';
import { getSellMatPays } from '../../../../services/material-services';
import AddIcon from '@mui/icons-material/Add';
import DialogPaysEdit from './dialog-pays-edit';
import { blue } from '@mui/material/colors';



function Row(props) {
    const { row, onClose, isAdmin } = props

    
    // useEffect(() => {

    // //   console.log("Row", title, row)
    // }, [row, title])
    
    const handleClose = (value) => {
        if(isAdmin){
            onClose(value)
        }
    }

  
  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset', backgroundColor: 'pink.text' } }}>
        <TableCell 
            component="th" 
            scope="row" 
            sx={{textAlign: 'center'}}
            >
            <Button onClick={() => handleClose(row)}>
                <Typography 
                    fontFamily='b_mitra' 
                    component="b"
                    variant="h6"
                    color='secondary'
                    >
                    {row.bio}
                </Typography>
            </Button>
        </TableCell>
        <TableCell align="right" sx={{textAlign: 'center'}}>
            <Typography 
                fontFamily='b_mitra' 
                component="b"
                variant="b"
                color={blue[900]}
                >
                  {row.credit}
                
            </Typography>
        </TableCell>
        <TableCell align="right" sx={{textAlign: 'center'}}>
            <Typography 
                fontFamily='b_mitra' 
                component="b"
                variant="b"
                color={blue[900]}
                >
                  {moment(row?.time, 'YYYY-M-D HH:mm').format('jYYYY/jM/jD HH:mm')}
            </Typography>
        </TableCell>
        <TableCell align="right" sx={{textAlign: 'center'}}>
            <Typography 
                fontFamily='b_mitra' 
                component="b"
                variant="b"
                color={blue[900]}
                >
                  {row.pay_status}
            </Typography>
        </TableCell>
        <TableCell align="right" sx={{textAlign: 'center'}}>
            <Typography 
                fontFamily='b_mitra' 
                component="b"
                variant="b"
                color={blue[900]}
                >
                {row.payways}
            </Typography>
        </TableCell>
        <TableCell align="right" sx={{textAlign: 'center'}}>
            <Typography 
                fontFamily='b_mitra' 
                component="b"
                variant="b"
                color={blue[900]}
                >
                {row.remarks}
            </Typography>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

Row.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  // selectedValue: PropTypes.string.isRequired,
}

export default function TabPays({userClient, ReqUser}) {
    const { authData } = useAuth()
    const [isAdmin, setIsAdmin] = useState(false)
    // const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [openDialog, setOpenDialog] = useState(false)
    const [dataUserReq, setDataUserReq] = useState()
    // const [bioStep, setBioStep] = useState()
    // const [dateExpire, setDateExpire] = useState()
    // const [detailID, setDetailID] = useState(0)
    const [rowSelect, setRowSelect] = useState()

    const getData = async() =>{
        await getSellMatPays(authData?.token, ReqUser.id)
        .then(data => {
            
            // console.log("TabPays", data)
            setDataUserReq(data?.results)
            
            // setUserClient(data?.results)

            setLoading(false)
        }).catch( e => {
            // setError(true)
            setLoading(false)
        })
    }
    useEffect(()=>{
        // console.log("SellWork", ReqUser.sell_req_buys.sell_mats)
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium)
        }
        
        setLoading(true)
        
        getData()
    }, [authData])

    const handleDialogShow = value => {
      if(value){
          setRowSelect(value)
      }
        setOpenDialog(true)
    }

    const handleDialogClose = () => {
        setOpenDialog(false)
        getData()
    }
    
  return (
    <React.Fragment>
      <div>
          <Fab 
              size="medium" color="secondary"
              role="presentation"
              onClick={handleDialogShow}
              >
              <AddIcon />
          </Fab>
          <TableContainer component={Paper} sx={{backgroundColor: blue[900]}}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'white'}
                            >
                            مشخصات
                        </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'white'}
                            >
                            مبلغ
                        </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'white'}
                            >
                            زمان پرداخت
                        </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'white'}
                            >
                            وضعیت
                        </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'white'}
                            >
                            روش پرداخت
                        </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'white'}
                            >
                            توضیحات
                        </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {isAdmin && dataUserReq && dataUserReq.sell_mat_credits.sell_credit_pays.map((row) => (
                        <Row 
                            key={row.id} 
                            row={row} 
                            onClose={handleDialogShow}
                            ReqUser={ReqUser}
                            isAdmin={isAdmin}
                            />
                    ))}
                </TableBody>
              </Table>

          </TableContainer>
          <DialogPaysEdit 
              dataUserReq={dataUserReq} 
              open={openDialog} 
              onClose={handleDialogClose}
              refRow={rowSelect}
              />
      </div>
      </React.Fragment>
    )
}